import { render } from "./MetodosLista.vue?vue&type=template&id=133a403c"
import script from "./MetodosLista.vue?vue&type=script&lang=js"
export * from "./MetodosLista.vue?vue&type=script&lang=js"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__